import {action, decorate, observable} from 'mobx';
import APIProxy from './APIProxy';
import LoginStore from './LoginStore';
import {isBlank} from './Util';
import {getWorkflow,autoLoginUrl} from '../stores/APIEndpoints';
import {toUrlParams} from "../stores/Util";

const blankCredentials = {
    email: '',
    token: '',
    role: '',
    username: '',
    userId: 0,
    user_type: '',
    capabilities: []
};

const INIT = 'init';
const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const IN_PROGRESS_MESSAGE = 'Authenticating...';
const SUCCESS = 'Authentication is successful.';
const INVALID_CREDENTIAL = 'Invalid Login Information';

class AppStore {
    credentials = blankCredentials;

    currentComponent = null;
    getWorkFlow = [];

    apiProxy = new APIProxy();
    loginStore = new LoginStore({apiProxy: this.apiProxy});
    menus = [];

    validationMessage = '';
    isEditable = true;
    state = INIT;

    constructor() {
        this.setSessionFromStorage();
        //this.getWorkflowList();
    }
    getWorkflowList = async () => {
     
        const bodyParams = {
            "where": {},
        }
        let response = await this.apiProxy.asyncPost(getWorkflow, bodyParams);
        const option = await response.json();
        this.setFilterworkflowOptions(0, option.map(t => ({
          name: t.name,
          label: t.name,
          value: t.id
        })));
      };
      setFilterworkflowOptions = (index, options) => {
        if(index == 0)
        {
            this.getWorkFlow=options;
            //console.log(this.getWorkFlow);
        }
    
    }
    setSessionFromStorage = () => {
        const storedCredentials = localStorage.getItem('credentials');

        if (storedCredentials !== null) {
            this.credentials = JSON.parse(storedCredentials);
            this.updateContext();
        } else {
            this.credentials = blankCredentials;
            this.updateContext();
        }
    };

    
    autoAuthenticate = async (queryParams) => {

        this.notifyProgress();
        this.credentials = blankCredentials;
        const response = await this.apiProxy.asyncPost(autoLoginUrl, {"email": queryParams["email"], "token": queryParams["token"]});
        //const response = await this.apiProxy.asyncPost(autoLoginUrl + '?' + toUrlParams(queryParams));
        const data = await response.json();
          console.log("autoAuthenticate")
        if (data == null || data.status != 200) {
            this.notifyError(INVALID_CREDENTIAL);
            return;
        }
        let capabilities = data.capabilities.map(a => a.id);
        this.credentials.email = data.user.email;
        this.credentials.token = data.user.token;
        this.credentials.role = data.user.user_type;
        this.credentials.username = data.user.full_name;
        this.credentials.user_type = capabilities.includes(20) || capabilities.includes(21) || capabilities.includes(10) || capabilities.includes("loose_leaf_management") ? "admin": "nothing"
        this.credentials.userId = data.user.id;
        this.credentials.capabilities = data.capabilities;

        this.apiProxy.updateCredentialHeaders(this.credentials);
        this.updateContext();
        this.persistCredentials();
        this.notifySuccess();
    }

    authenticate = async () => {
        console.log("authenticatePrint")
        this.notifyProgress();

        this.credentials = blankCredentials;
        const data = await this.loginStore.authenticate();
        if (data == null || data.token == null) {
            this.notifyError(INVALID_CREDENTIAL);
            return;
        }
        this.credentials.email = data.email;
        this.credentials.token = data.token;
        this.credentials.role = data.role;
        this.credentials.username = data.name;
        this.credentials.user_type = data.user_type;
        this.credentials.userId = data.user_id;
        this.credentials.capabilities = data.capabilities;
        console.log(data.role, data.user_type)

        this.apiProxy.updateCredentialHeaders(this.credentials);

        this.updateContext();
        this.persistCredentials();
        this.notifySuccess();
    }

    notifyError = (errorMessage) => {
        this.state = ERROR;
        this.isEditable = true;
        this.validationMessage = errorMessage;
    };

    notifyProgress = () => {
        this.state = PENDING;
        this.isEditable = false;
        this.validationMessage = IN_PROGRESS_MESSAGE;
    };

    notifySuccess = () => {
        this.state = DONE;
        this.isEditable = false;
        this.validationMessage = SUCCESS;
    };


    persistCredentials = () => {
        localStorage.setItem('credentials', JSON.stringify(this.credentials));
    };

    updateContext = () => {
        this.apiProxy.updateCredentialHeaders(this.credentials);
        this.resolveMenu();
        this.resolveLandingPage();
    };

    resolveMenu() {
        let menus = require('./menus/GuestMenu.json');
        // eslint-disable-next-line default-case
      //  switch (this.credentials.user_type) {
        switch (this.credentials.user_type) {
            case 'cm':
            case 'admin': {
                menus = require('./menus/CmMenu.json');
                break;
            }
            case 'editor': {
                menus = require('./menus/EditorMenu.json');
                break;
            }
        }
        this.menus = menus;
    }

    resolveLandingPage = () => {
        const landingPage = this.menus.find(menu => menu.isLandingPage);
        this.transitionTo(landingPage.key);
    };

    transitionTo = key => {
        this.currentComponent = this.menus.find(menu => menu.key === key);
    };

    isLoggedIn = () => {
        return !(isBlank(this.credentials.email) || isBlank(this.credentials.token))
    };

    logout = () => {
        localStorage.setItem('credentials', JSON.stringify(blankCredentials));
        window.location.href = "/";
    };

    isLooseLeafPm = () => this.credentials.capabilities.includes('loose_leaf_pm');

    isLooseLeafAdmin = () => this.credentials.capabilities.includes('loose_leaf_admin');

   
}

decorate(AppStore, {
    state: observable,
    validationMessage: observable,
    isEditable: observable,
    getWorkFlow:observable,
    currentComponent: observable,
    credentials: observable,
    setCredentials: action,
    logout: action,
    authenticate: action,
    transitionTo: action
});

export const appStore = new AppStore();
